import React from "react";
import "./Soci.scss";
import socis from "../SocisList";
import { User } from "../../../../../Dashboard";

class Input extends React.Component<{
  label: string;
  name: string;
  type: string;
  obligatori?: boolean;
  value?: string | number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}, {}> {
  render(): React.ReactNode {
    return (
      <div className={`input ${this.props.name}`}>
        <label htmlFor={this.props.name} className={this.props.obligatori && 'obligatori'}>{this.props.label}</label>
        <input type={this.props.type} name={this.props.name} value={this.props.value} />
      </div>
    );
  }
}

export default class Soci extends React.Component<{}, {
  data: any;
}> {
  constructor(props: any) {
    super(props);
    const id = Number(window.location.pathname.match(/\d+/));
    this.state = {
      data: socis.find(soci => soci.id === id)
    };
  }

  render(): React.ReactNode {
    return (
      <User.Consumer>
        {(context) => {
          const { id, nom, cognoms, malnom, email } = this.state.data;
          return (
            <div className="soci" style={{ '--accentColor': context.accent } as React.CSSProperties}>
              <img className="foto" src="Fotografia del Soci" alt="" />
              <Input name="sobrenom" type="text" label="Sobrenom" obligatori value={malnom} />
              <Input name="nom" type="text" label="Nom" value={nom.join(' ')} />
              <Input name="cognoms" type="text" label="Cognoms" value={cognoms.join(' ')} />
              <Input name="naixement" type="date" label="Data de Naixement" />
              <Input name="unio" type="date" label="Data d'Unió a la Colla" obligatori />
              <Input name="correu" type="text" label="Correu Electronic" value={email} />
            </div>
          )
        }}
      </User.Consumer>
    );
  }
}